module.exports = __webpack_public_path__ + "img/cpjs4.6c3db806.png";